import { localisedValue } from "utils"

/**
 * Maps hierarchical client type API response to tree shape with key, label, value, children.
 * Used only when getClientType is called with hierarchical: true (e.g. for filters).
 */
const hierarchicalClientTypeTransformer = data => {
  if (!Array.isArray(data)) return []
  return data.map(item => ({
    key: item.id?.toString(),
    label: localisedValue({ object: item, key: "name" }),
    value: item.id?.toString(),
    ...(item.children?.length
      ? { children: hierarchicalClientTypeTransformer(item.children) }
      : {}),
  }))
}

export default hierarchicalClientTypeTransformer
